import { defineStore } from 'pinia'
import {getSecureCookieOptions} from "/utils/cookieOptions";

const TOKEN_VALIDITY_HOURS = 10; // backend 11 hours

export const useAuthIntranetStore = defineStore('authIntranetStore', {
    
    state: () => ({
        isLoggedInIntranet: false,
        user: null,
        token: null,
        tokenExpiresAt:null,
    }),
    getters: {
        // loggedIn: (state) => state.isLoggedInIntranet,
        getToken: (state) => {
            if (!state.token || !state.tokenExpiresAt) return null;
            return Date.now() < state.tokenExpiresAt ? state.token : null;
        }
    },
    actions: {
        handleDoLogin(user) {
            this.isLoggedInIntranet = true;
            this.user = user;
            

        },
        setToken(token){
            this.token = token;
            this.tokenExpiresAt =  Date.now() +TOKEN_VALIDITY_HOURS * 60 * 60 * 1000;
        },

        isIntranet() {
            const runtimeConfig = useRuntimeConfig();
            return runtimeConfig.public.IS_INTRANET
        },
        intranetInloggen() {
            // authorisation needed for intranet
            const runtimeConfig = useRuntimeConfig();
            return runtimeConfig.public.INTRANET_INLOGGEN
        },        
        clearLoginData() {
            this.user = null;
            this.isLoggedInIntranet = false
            this.token = null;
            this.tokenExpiresAt = null;
        },
        clearIfExpired() {
            if ((this.token || this.isLoggedInIntranet) && (!this.tokenExpiresAt || Date.now() >= this.tokenExpiresAt)) {
                this.clearLoginData();
            }
        },
    },
    persist: [
    {
      storage: piniaPluginPersistedstate.cookies({
            ...getSecureCookieOptions(),
            maxAge: TOKEN_VALIDITY_HOURS * 60 * 60,
       }),
      pick: ['token', 'user', 'isLoggedInIntranet','tokenExpiresAt'],
    }
  ]
});
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAuthIntranetStore, import.meta.hot))
}
